import { Component, OnInit } from '@angular/core';
import { Role } from './../../../model/role';
import { RolesService } from '../../../service/component_dependent/users/roles.service';


@Component({
  selector: 'app-create-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  public roles: Role[];

  public keyword: string;

  public maxItemPerPage: number;
  public page: number;
  public lastPage: number;
  public total: number;

  protected loading: boolean;

  constructor(private roleService: RolesService) {
    this.maxItemPerPage = 5;
    this.page = 1;
    this.keyword = "";
  }

  ngOnInit() {
    this.getRoles(this.maxItemPerPage, this.page, this.keyword);
  }

  public readonly TABLE_HEADERS = [
    'Name', 'Display Name', 'Description'
  ];

  public getRoles(maxItemPerPage, page, keyword) {
    this.loading = true;
    this.roleService.getRoles(maxItemPerPage, page, keyword).subscribe(
      data => {
        this.loading = false;
        this.reassignVariables(data.data);
      }
    )
  }

  private reassignVariables(data) {
    this.roles = data.data;
    this.maxItemPerPage = data.per_page;
    this.page = data.current_page;
    this.lastPage = data.last_page;
    this.total = data.total;
  }

}
